<!--
  - Copyright (c) 2021. Catch Bangladesh / BitFlex. All rights reserved.
  -->

<template>
    <div class="lg:px-20 px-2 mt-8">
                <span class="text-primary font-bold text-2xl mt-8">
                    TERMS AND CONDITIONS
                </span>
                <br>
                <br>
                <span class="text-primary  text-lg mt-8">
                 Welcome to AstharProtik.
                </span>
                <br>
                <br>
                <span>
                    AstharProtik’s services are powered by Catch Bangladesh. As some of our Services may be software-based that are
                    downloaded to your computer, phone, tablet, or other devices. You agree that we may automatically update this
                    software and that these Terms will apply to such updates. Please read these Terms carefully, and contact us if
                    you have any questions. By using our Services; you agree to be bound by these Terms, including the policies
                    referenced in these Terms.
                </span>
            <br>
            <br>
            <span class="text-primary font-bold text-2xl mt-8">
                Using AstharProtik
            </span>
            <br>
            <br>
            <span class="text-primary text-xl">
                Who May Use our Services
            </span>
            <br>
            <br>
            You may use our Services only if you can form a binding contract with AstharProtik, and only in compliance with these
            Terms and all applicable laws. When you create your account on AstharProtik and subsequently you use certain features.
            You must provide us your accurate and complete information and you agree to update your information to keep it accurate
            all the time. Also certain regions and may have additional requirements and restrictions.
            <br>
            <br>
            <span class="text-primary text-xl">
                Our License to You
            </span>
            <br>
            <br>
                Subject to these Terms and our policies (including the Acceptable Use Policy, Moral Code, and other terms),
            we grant you a limited, personal, non-exclusive, non-transferable, and revocable license to use our Services.
            You do agree that you will create, access, and/or use only one user account unless expressly permitted by AstharProtik.
            Also, you will not share with any third-party to access information for your account.
            <br>
            <br>

            <span class="text-primary font-bold text-2xl mt-8">
                Service Offerings
            </span>
            <br>
            <br>
            <span class="text-primary text-xl">
                Changes to service offerings
            </span>
            <br>
            <br>
                AstharProtik offers services for automating your business and provides you a complete digital solution through
            our expert team. AstharProtik holds the right to change, interrupt, or modify any service offerings. Service Offerings
            are subject to the Disclaimers and Limitation of Liability sections below. To access shop service offered by AstharProtik
            business owners must become an authorized seller of AstharProtik by providing all required information on AstharProtik. And
            users must register their accounts before starting using the app by providing a full legal name, contact number, valid
            email address, and other information as required.
           <br>
            <br>
            <span class="text-primary text-xl">
                Security
            </span>
            <br>
            <br>
                We care about the security of our users. While we work to protect the security of your account and related information ,
            AstharProtik also takes security measures to prevent unwanted troubles or breach in the system. But AstharProtik can't ensure
            that unapproved outsiders won't have the option to overcome our safety efforts. And a user must not share their registered
            information of AstharProtik to other peoples or third parties. And do not spread any third party links or malware using our
            platform. Which is strictly prohibited and AstharProtik has the right to take action against them. Please notify us
            immediately of any compromise or unauthorized use of your account by emailing support@astharprotik.com
            <br>
            <br>
            <span class="text-primary text-xl">
                Modifying and Terminating our Services
            </span>
            <br>
            <br>
                We are constantly changing and improving our Services. We may add or remove functions, features or requirements
            and we may suspend or stop part of our Services altogether. Accordingly, AstharProtik may terminate your use of any Service
            for any reason. If your use of a paid Service is terminated, a refund may be available under our Refund Policy.
            We may not be able to deliver the Services to certain regions or countries for various reasons, including due to
            applicable export control requirements or internet access limitations and restrictions from governments.
            You can stop using our Services at any time, although we’ll be sorry to see you go.
            <br>
            <br>
            <span class="text-primary text-xl">
                Disclaimers
            </span>
            <br>
            <br>
                The services and all included content are provided based on without warranty of any kind, whether express or implied.
            The AstharProtik parties specifically disclaim any and all warranties and conditions of merchantability, fitness for a
            particular purpose along with non-infringement. Any warranties arising out of course of dealing or usage of trade.
            AstharProtik further disclaim any and all liability related to your access or use of the services. You acknowledge and
            agree that any access to or use of the services is at your own risk.
            <br>
            <br>
            <span class="text-primary text-xl">
            Limitation of Liability
            </span>
            <br>
            <br>
                To the maximum extent permitted by law, the AstharProtik parties shall not be liable for any indirect, incidental,
            special, consequential, or punitive damages. Also, any loss of profits or revenues, whether incurred directly-indirectly,
            loss of data, use, goodwill, or other intangible losses. Resulting from
                <br>
            (a) your access to use, inability to use the services;
            <br>
            (b) conduct or content of any party rather than the applicable AstharProtik party, including without limitation,
            any defamatory, offensive or illegal conduct;
            <br>
            (c) unauthorized access, use, alteration of your content, or information, in no event shall AstharProtik's aggregate
            liability for all claims the total amount of fees received by AstharProtik from you for the use of paid services during
            the past six months, whichever is greater.
            <br>
            You acknowledge and agree that the disclaimers and the limitations of liability outlined in these terms of use reflect a reasonable and fair allocation of risk between you and the AstharProtik parties. These limitations are an essential basis to AstharProtik’s ability to make the services available to you on an economically feasible basis.
            You also agree that any cause of action related to the services must commence within one (1) year after the cause of action accrues. Otherwise, such a cause of action is permanently barred.
            <br>
            <br>
            <span class="text-primary text-xl">
                Compensation
            </span>
            <br>
            <br>
                You agree to protect, defend, and hold harmless of the AstharProtik parties from any claims, liabilities, expenses
            and damages, including reasonable attorneys’ fees and costs, made by any third party related to
            <br>
            (a) your use or attempted use of the Services in violation of these Terms;
            <br>
            (b) your violation of any law or rights of any third party;
            <br>
            (c) User Content, including without limitation any claim of infringement or misappropriation of intellectual property or
            other proprietary rights.
            <br>
            <br>
            <span class="text-primary text-xl">
                Governing Law and Jurisdiction
            </span>
            <br>
            <br>
                The Services are managed by AstharProtik, which is powered by Catch Bangladesh, located in Dhaka, Bangladesh.
            Any dispute related to these Terms will be governed by the laws of the Bangladesh Government, excluding its conflicts of
            law provisions. You further consent to the personal jurisdiction of an exclusive venue in the federal and state courts
            located in and serving Dhaka, Bangladesh as the legal forum for any such dispute.
            <br>
            <br>
            <span class="text-primary font-bold text-2xl">

                General Terms
            </span>
            <br>
            <br>
            <span class="text-primary text-xl">
                Revisions to the Terms
            </span>
            <br>
            <br>
                We hold the right to revise the Terms at our sole discretion at any time. Any revisions to the Terms will be
            effective immediately upon posting by us. For any material changes to the Terms, we will take reasonable steps to
            notify you of such changes via a banner on the website, email notification, another method, or combination of methods.
            In all cases, your continued use of the services after publication of such changes with or without notification
            constitutes binding acceptance of the revised Terms.
<br>
<br>
            <span class="text-primary text-xl">
                Severability Waiver
            </span>
            <br>
            <br>

                If it turns out that a particular provision of these Terms is not enforceable,
            this will not affect any other terms. If you do not comply with these Terms, and we do not take immediate action.
            This does not indicate that we relinquish any rights that we may have (such as taking action in the future).
            <br>
            <br>
            <span class="text-primary font-bold text-2xl">

                Referenced Policies
            </span>
            <br>
            <br>
                Acceptable Use Policy
            <br>
            Copyright and Trademark Infringement Policy
               <br>
            Refund Policy
            <br>
            Moral Code
            <br>
            <br>
            <span class="text-primary font-bold text-2xl">

                Acceptable Use Policy
            </span>
            <br>
            <br>
                AstharProtik’s mission is to provide a digital business solution. We want to make sure that all of our users
            feel safe and comfortable while using our Services. We have drafted this Policy to ensure that people understand and
            follow the rules when participating in our online community and otherwise using our Services.
            <br>
            <br>
                We may remove or edit inappropriate content or activity identified by or reported to us or suspend, disable
            or terminate a user’s access to all or part of the Services.
<br>
<br>
            <span class="text-danger text-xl">

                You are prohibited from using our Services to share content that:
            </span>
            <br>
                <span class="text-primary text-xl ml-6">1.</span>
                Contains illegal content or promotes illegal activities with the intent to commit such activities.

                <br>
                <span class="text-primary text-xl ml-6">2.</span>

                    Contains credible threats or organizes acts of real-world violence. We don’t allow content that creates a genuine
                    risk of physical injury or property damage, credibly threatens people or public safety, or organizes or encourages harm.
                <br>
                <span class="text-primary text-xl ml-6">3.</span>

                    Harasses others. We encourage commentary about people and matters of public interest but abusive. Otherwise
                    inappropriate content directed at private individuals is not allowed.
                <br>
                <span class="text-primary text-xl ml-6">4.</span>

                    Violates intellectual property, privacy, or other rights. Do not share content that you do not have the right to share,
                    claim content that you did not create as your own, or otherwise infringe or misappropriate someone else’s intellectual
                    property or other rights. Always attribute materials used or quoted by you to the original copyright owner.
                <br>
                <span class="text-primary text-xl ml-6">5.</span>

                    Sharing political and religion-based news, contents are strictly prohibited
                <br>
                <span class="text-primary text-xl ml-6">6.</span>

                    Otherwise violates the AstharProtik’s Terms of Use. Please note that specific service offerings may have
                    additional rules and requirements.
            <br>
            <br>
            <span class="text-danger text-xl">
                You also aren’t allowed to:
            </span>
            <br>
            <br>
            <span class="text-primary text-xl ml-6">1.</span>
                Do anything that violates local, state, national, or international law or breaches any of your contractual obligations or fiduciary duties.
            <br>
            <span class="text-primary text-xl ml-6">2.</span>
                Share your password, let anyone access your account, or do anything that might put your account at risk.
            <br>
            <span class="text-primary text-xl ml-6">3.</span>
                Attempt to access any other user’s account.
            <br>
            <span class="text-primary text-xl ml-6">4.</span>
                Access, tamper with, or use non-public areas of our systems unless specifically authorized to do so.
            <br>
            <span class="text-primary text-xl ml-6">5.</span>
            Break or circumvent our authentication or security measures or otherwise test the vulnerability of our systems or networks, unless specifically authorized to do so.
            <br>
            <span class="text-primary text-xl ml-6">6.</span>
            Try to reverse engineer any portion of our Services.
               <br>
            <span class="text-primary text-xl ml-6">7.</span>
                Try to interfere with any user, host, or network, for example by sending a virus, overloading, spamming, or mail-bombing.
            <br>
            <span class="text-primary text-xl ml-6">8.</span>
                Use our Services to prevent malware.
            <br>
            <span class="text-primary text-xl ml-6">9.</span>
                All sorts of bullying and shaming (HIV, fat, Femme, slut, bottom, homophobic or Transphobic Slurs, racism, identity, addiction, age) also use of inappropriate words and signs are also not allowed under the rules of AstharProtik.
            <br>
            <span class="text-primary text-xl ml-6">10.</span>
                Use of our services or any functionality of the Platform for anything other than for completing online courses or for pedagogical purposes.
            <br>
            <span class="text-primary text-xl ml-6">11.</span>
                Impersonate or misrepresent your affiliation with any person or entity.
            <br>
            <span class="text-primary text-xl ml-6">12.</span>
            Encourage or help anyone do any of the things on this list.
            <br>
            <br>
            <span class="text-primary font-bold text-2xl">
                Copyright and Trademark Policy
            </span>
            <br>
            <br>
                AstharProtik respects the intellectual property rights of our sellers and business owners and expects our users to
            do the same when using the Services. We reserve the right to suspend, disable, or terminate the accounts of users who
            repeatedly infringe or are repeatedly charged with infringing the copyrights, trademarks, or other intellectual property
            rights of others.
            <br>
            <br>
                If you believe in good faith that materials on the Services infringe your copyright, the Act provides that you may
            send us a notice requesting that the material be removed or access to it blocked.
            <br>
            <br>
            <span class="text-primary font-bold text-2xl">

                The notice must include the following information:
            </span>
                <br>
                <br>

            <span class="ml-6"> The physical or electronic signature of a person authorized to act on behalf of the owner of an exclusive right that
                is allegedly infringed;</span>
            <br>
            <span class="ml-6">
                Identification of the copyrighted work claimed to have been infringed (or if multiple copyrighted works located on
                the Services are covered by a single notification, a representative list of such works);
            </span>
            <br>

            <span class="ml-6">
                Identification of the material that is claimed to be infringing or the subject of infringing activity, and information
                reasonably sufficient to allow AstharProtik to locate the material on the Services;
            </span>
            <br>
            <span class="ml-6">
                The name, address, telephone number, and email address (if available) of the complaining party;
            </span>
            <br>
            <span class="ml-6"> A statement that the information in the notification is accurate and, under penalty of perjury, that the complaining
            party is authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.
            </span>
            <br>
            <br>
                Notices must meet the then-current statutory requirements imposed by the Act. Notices and counter-notices concerning
            the Services can either be sent via email: support@astharprotik.shop
            <br>
            <br>
                We suggest that you consult your legal advisor before filing a notice. Also, be aware that there can be penalties for
            false claims under the ACT.
            <br>
            <br>

                AstharProtik also respects the trademark rights of others. Accounts with any other content that misleads others or
            violates another’s trademark may be updated, suspended, disabled, or terminated by AstharProtik in its sole discretion.
            If you are concerned that someone may be using your trademark in an infringing way on our Services, please email us at
            support@astharprotik.shop

            <br>
            <br>
                and we will review your complaint. If we deem appropriate, we may remove the offending content, warn the individual
            who posted the content, and/or temporarily or permanently suspend or disable the individual’s account.
            <br>
            <br>
            <span class="text-primary text-2xl font-bold">
                Refund Policy
            </span>
            <br>
            <br>
                For details on our refund deadlines and policies, please refer to the information below. There are subscription
            payments for our services. Please also note that we treat violations of our Terms of Use and Moral Code very seriously,
            and we have no obligation to offer refunds to users who violate these terms, even if their requests are made within the
            designated refund period.

            <br>
            <br>

                For more information about our refund process, including instructions for requesting a refund,
            you may visit our office .
            <br>
            <br>
            <span class="text-primary font-bold text-2xl">
                For Other Paid Services
            </span>
            <br>
            <br>
                Except as described in this Refund Policy or as explicitly stated as part of the sign-up process for a Service, C
            atch Mart has no obligation to provide refunds or vouchers for any other Services.
            <br>
            <br>
            <span class="text-primary font-bold text-2xl">
                Feedback
            </span>
            <br>
            <br>

                We welcome your suggestions, ideas, comments, and other feedback regarding the services. By submitting any Feedback,
            you grant us the right to use the Feedback without any restriction or any compensation to you. By accepting your feedback,
            AstharProtik does not waive any rights to use similar or related Feedback previously known to AstharProtik, developed by its
            employees or contractors, or obtained from other sources.
            <br>
            <br>









                _______________________________________________________________________________________________________________________________________
            <br>
            ***These terms and conditions have been set by AstharProtik. Any changes made by AstharProtik  is applied to customers and clients***
    </div>
</template>

<script>
export default {
    name: "termsandconnditions"
}
</script>

<style scoped>

</style>
